import APIClient from '@app/services/APIClient';
import { transformData } from '@app/services/deposit/dataTransformer';
import ui from '@app/services/deposit/ui';
import Deposit from '@engine/engine/deposit/Deposit';

// https://webpack.js.org/guides/public-path/
__webpack_public_path__ = window.resourceBaseUrl || '';

const dataset = document.querySelector('#app').dataset;
const productRatesHandler = (rates) => {
    // for testing purposes dummy-*.js may be used instead of rates form api call:
    //const rawData = require('../dummy-data/deposit/different-terms.js').default;

    const rawData = rates.data.data[0];
    const rawDefaultValues = JSON.parse(dataset.default);
    const transformedData = transformData({ rawData, rawDefaultValues });
    const externalHandler = (userInput) => {
        if (!deposit) {
            deposit = new Deposit(rawData, userInput);
        } else {
            deposit.setInput(userInput);
        }

        return deposit.calculate();
    };
    let deposit;

    // TODO: refactor this
    transformedData.ctaLink = dataset.ctaLink?.trim();
    transformedData.ctaText = dataset.ctaText?.trim();
    ui.init({ data: transformedData, externalHandler });
};

APIClient.getProductRates(dataset).then(productRatesHandler);
